import gsRequest from '@/api/gsRequest';

export const getStoreInfoPublic = (storeId, options) => {
  return gsRequest({
    url: '/web/store/' + storeId + '/webInfo',
    method: 'get',
    params: options
  });
};

export const userLogin = (data) => {
  return gsRequest({
    url: '/web/user/login',
    method: 'post',
    data
  });
};

export const userLogout = () => {
  return gsRequest({
    url: '/web/user/logout',
    method: 'post'
  });
};

export const getUserInfo = () => {
  return gsRequest({
    url: '/web/user/info',
    method: 'get'
  });
};

export const updateLoginPwd = (data) => {
  return gsRequest({
    url: '/web/user/updateLoginPwd',
    method: 'post',
    data
  });
};

export const pubStoreSpecAction = (storeId, action, data) => {
  return gsRequest({
    url: '/web/store/' + storeId + '/pubaction/' + action,
    method: 'post',
    data: { data }
  });
};

export const pubGetTeamMembers = (storeId, data = {}) => {
  return pubStoreSpecAction(storeId, 'pubGetTeamMembers', data);
};

export const pubGetSupportingTeams = (storeId, data = {}) => {
  return pubStoreSpecAction(storeId, 'pubGetSupportingTeams', data);
};

export const storeSpecAction = (storeId, action, data) => {
  return gsRequest({
    url: '/bkgen/store/' + storeId + '/action/' + action,
    method: 'post',
    data: { data }
  });
};

export const pubListDocs = (storeId, params) => {
  return gsRequest({
    url: '/web/store/' + storeId + '/pubListDocs',
    method: 'get',
    params
  });
};

export const pubRequstDoc = (storeId, data = {}) => {
  return pubStoreSpecAction(storeId, 'pubRequstDoc', data);
};
